/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomQuestionnaireRadioAnswerRead } from './CustomQuestionnaireRadioAnswerRead';
import {
  CustomQuestionnaireRadioAnswerReadFromJSON,
  CustomQuestionnaireRadioAnswerReadFromJSONTyped,
  CustomQuestionnaireRadioAnswerReadToJSON,
} from './CustomQuestionnaireRadioAnswerRead';
import type { CustomQuestionnaireMultiSelectAnswerRead } from './CustomQuestionnaireMultiSelectAnswerRead';
import {
  CustomQuestionnaireMultiSelectAnswerReadFromJSON,
  CustomQuestionnaireMultiSelectAnswerReadFromJSONTyped,
  CustomQuestionnaireMultiSelectAnswerReadToJSON,
} from './CustomQuestionnaireMultiSelectAnswerRead';
import type { CustomQuestionnaireQuestionForAnswer } from './CustomQuestionnaireQuestionForAnswer';
import {
  CustomQuestionnaireQuestionForAnswerFromJSON,
  CustomQuestionnaireQuestionForAnswerFromJSONTyped,
  CustomQuestionnaireQuestionForAnswerToJSON,
} from './CustomQuestionnaireQuestionForAnswer';
import type { CustomQuestionnaireFreeTextAnswer } from './CustomQuestionnaireFreeTextAnswer';
import {
  CustomQuestionnaireFreeTextAnswerFromJSON,
  CustomQuestionnaireFreeTextAnswerFromJSONTyped,
  CustomQuestionnaireFreeTextAnswerToJSON,
} from './CustomQuestionnaireFreeTextAnswer';

/**
 * Adds nested create feature
 * @export
 * @interface CustomQuestionnaireAnswerRead
 */
export interface CustomQuestionnaireAnswerRead {
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireAnswerRead
   */
  id?: number;
  /**
   *
   * @type {CustomQuestionnaireQuestionForAnswer}
   * @memberof CustomQuestionnaireAnswerRead
   */
  readonly question: CustomQuestionnaireQuestionForAnswer;
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireAnswerRead
   */
  questionId: number;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaireAnswerRead
   */
  readonly timestamp: string;
  /**
   *
   * @type {CustomQuestionnaireRadioAnswerRead}
   * @memberof CustomQuestionnaireAnswerRead
   */
  radioAnswer?: CustomQuestionnaireRadioAnswerRead | null;
  /**
   *
   * @type {CustomQuestionnaireMultiSelectAnswerRead}
   * @memberof CustomQuestionnaireAnswerRead
   */
  multiSelectAnswer?: CustomQuestionnaireMultiSelectAnswerRead | null;
  /**
   *
   * @type {CustomQuestionnaireFreeTextAnswer}
   * @memberof CustomQuestionnaireAnswerRead
   */
  freeTextAnswer?: CustomQuestionnaireFreeTextAnswer | null;
}

/**
 * Check if a given object implements the CustomQuestionnaireAnswerRead interface.
 */
export function instanceOfCustomQuestionnaireAnswerRead(value: object): value is CustomQuestionnaireAnswerRead {
  if (!('question' in value) || value['question'] === undefined) return false;
  if (!('questionId' in value) || value['questionId'] === undefined) return false;
  if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
  return true;
}

export function CustomQuestionnaireAnswerReadFromJSON(json: any): CustomQuestionnaireAnswerRead {
  return CustomQuestionnaireAnswerReadFromJSONTyped(json, false);
}

export function CustomQuestionnaireAnswerReadFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomQuestionnaireAnswerRead {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    question: CustomQuestionnaireQuestionForAnswerFromJSON(json['question']),
    questionId: json['question_id'],
    timestamp: json['timestamp'],
    radioAnswer:
      json['radio_answer'] == null ? undefined : CustomQuestionnaireRadioAnswerReadFromJSON(json['radio_answer']),
    multiSelectAnswer:
      json['multi_select_answer'] == null
        ? undefined
        : CustomQuestionnaireMultiSelectAnswerReadFromJSON(json['multi_select_answer']),
    freeTextAnswer:
      json['free_text_answer'] == null
        ? undefined
        : CustomQuestionnaireFreeTextAnswerFromJSON(json['free_text_answer']),
  };
}

export function CustomQuestionnaireAnswerReadToJSON(
  value?: Omit<CustomQuestionnaireAnswerRead, 'question' | 'timestamp'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    id: value['id'],
    question_id: value['questionId'],
    radio_answer: CustomQuestionnaireRadioAnswerReadToJSON(value['radioAnswer']),
    multi_select_answer: CustomQuestionnaireMultiSelectAnswerReadToJSON(value['multiSelectAnswer']),
    free_text_answer: CustomQuestionnaireFreeTextAnswerToJSON(value['freeTextAnswer']),
  };
}
